const TH = {
  Lang: {
    Code: "TH",
    TextEN: "ภาษาอังกฤษ",
    TextVN: "ภาษาเวียดนาม",
  },
  Login: {
    ErrorEmail: "กรุณากรอกอีเมล!",

    LoginDescription: "กรอกอีเมลและรหัสผ่านของคุณเพื่อเข้าสู่ระบบ",
    ButtonText: "เข้าสู่ระบบ",
  },
  hero: {
    title: "เครื่องมือ AI อเนกประสงค์ของคุณ",
    description: "แปลภาษาและแปลไฟล์ได้อย่างรวดเร็วด้วยเทคโนโลยี AI ขั้นสูง",
  },

  tabs: {
    translate: "แปลภาษา",
    file: "แปลไฟล์",
    compress: "บีบอัดรูปภาพ",
  },

  file: {
    section_title: "แปลไฟล์",
    section_description: "อัปโหลดไฟล์และแปลเนื้อหาทั้งหมดเป็นภาษาอื่น",
    from_language: "ภาษาต้นฉบับ",
    to_language: "ภาษาเป้าหมาย",
    drag_text: "ลากและวางไฟล์ที่นี่ หรือ",
    choose_file: "เลือกไฟล์",
    support_text: "รองรับ DOC, DOCX, XLSX, PPTX, PDF",
    translating: "กำลังแปลเอกสาร...",
    translating_short: "📄 กำลังแปล",
    translating_short_complete: "📄 กำลังแปลเอกสารทั้งหมด",
    translate_now: "แปลทันที",
    downloadUrlNotFound: "ไม่พบลิงก์ไฟล์",
    reading_file: "กำลังอ่านเอกสาร...",
    character_limit_warning:
      "ไฟล์มี {{current}} อักขระ ซึ่งเกินขีดจำกัด {{limit}} อักขระที่อนุญาตสำหรับการแปลฟรี",
  },

  note: {
    review_note_before: "หมายเหตุ: วันนี้คุณเหลือ",
    review_note_after: "ครั้งสำหรับการแปลเอกสารฟรี",
    line1: "● แปลได้หลายรูปแบบ: Word, Excel, PPTX...",
    line2:
      "● รักษาเค้าโครง ตาราง และรูปภาพเดิม พร้อมดูตัวอย่างงานแปลก่อนชำระเงิน",
    line3: "● รองรับภาษายอดนิยมและภาษาเฉพาะทางหลายภาษา",
    line4: "● ประมวลผลรวดเร็ว ใช้งานง่าย ไม่จำเป็นต้องมีความรู้ด้านเทคนิค",
    line5: "● บันทึกประวัติการแปล เพื่อให้ผู้ใช้ดาวน์โหลดได้สะดวก",
    warning:
      "* หมายเหตุ: หลังการแปล จำนวนคำในภาษาปลายทางอาจยาวหรือสั้นกว่าเค้าโครงเดิม กรุณาปรับขนาดตัวอักษรให้เหมาะสมกับเลย์เอาต์",
  },

  preview: {
    loading_title: "กำลังเตรียมตัวอย่างเอกสาร...",
    loading_desc: "AI กำลังเรนเดอร์เอกสาร กรุณารอสักครู่",
    title: "📄 ดูตัวอย่างเอกสาร",
    note: "ชำระเงินทันทีเพื่อดาวน์โหลดไฟล์แปลฉบับสมบูรณ์",
    choose_payment_method: "เลือกวิธีการชำระเงิน",
    payment: "ชำระเงิน",
    download: "ดาวน์โหลด",
    must_pay: "กรุณาชำระเงินก่อนดาวน์โหลด",
  },

  feature: {
    format: {
      title: "รองรับหลายรูปแบบ",
      desc: "รองรับ PDF, Word, TXT",
    },
    security: {
      title: "ความปลอดภัย",
      desc: "ไฟล์ถูกเข้ารหัสอย่างปลอดภัย",
    },
    layout: {
      title: "คงรูปแบบเดิม",
      desc: "รักษาเค้าโครงต้นฉบับ",
    },
  },

  auth: {
    login_required: "กรุณาเข้าสู่ระบบเพื่อใช้งานฟังก์ชันนี้!",
    loginSuccess: "เข้าสู่ระบบสำเร็จ",
    loginFailed: "❌ เข้าสู่ระบบไม่สำเร็จ",
  },

  error: {
    upload_fail: "❌ ไม่สามารถอัปโหลดไฟล์ได้",
    unsupported_format: "❌ ไม่รองรับรูปแบบไฟล์นี้",
    translate_fail: "❌ เกิดข้อผิดพลาดระหว่างการแปลไฟล์ กรุณาลองอีกครั้ง",
    qr_fail: "❌ ไม่สามารถดึงรหัสชำระเงินได้",
  },

  pdf: {
    selectPdfProcessingModeBeforeStart:
      "ไฟล์ PDF จำเป็นต้องเลือกโหมดการประมวลผลก่อนเริ่มแปล",
    selectPdfTranslationMode: "เลือกโหมดการแปล PDF",
    only_text: {
      title: "แปลเฉพาะข้อความ โดยคงรูปภาพเดิมไว้",
      desc: "คงรูปภาพและเค้าโครง PDF เดิมไว้ และแปลเฉพาะเนื้อหาข้อความ ไฟล์หลังแปลสามารถแก้ไขได้",
    },
    text_or_image: {
      title: "แปลเนื้อหาและข้อความในรูปภาพทั้งหมดในไฟล์",
      desc: "แปลทั้งข้อความและข้อความที่อยู่ในรูปภาพ พร้อมรักษาเค้าโครงของไฟล์เดิม ไฟล์หลังแปลสามารถแก้ไขได้",
    },
    full_image: {
      title: "แปลเป็น PDF แบบรูปภาพ",
      desc: "ส่งออกผลลัพธ์เป็นไฟล์ PDF ที่ประกอบด้วยรูปภาพหลังการแปล",
    },
  },

  common: {
    close: "ปิด",
    loading: "กำลังโหลด...",
    noData: "ไม่มีข้อมูล",
    loadMore: "ดูเพิ่มเติม",
    ok: "ตกลง",
    delete: "ลบ",
  },

  menu: {
    home: "หน้าแรก",
    blog: "บล็อก",
    faq: "คำถามที่พบบ่อย",
  },

  user: {
    transactionHistory: "ประวัติการทำรายการ",
    logout: "ออกจากระบบ",
  },

  blog: {
    notFound: "ไม่พบบทความ",
    relatedPosts: "บทความที่เกี่ยวข้อง",
    authorAdmin: "ผู้ดูแลระบบ",
    pageTitle: "บล็อกและการแบ่งปัน",
    pageDescription: "ความรู้ คู่มือ และอัปเดตล่าสุดเกี่ยวกับเครื่องมือ AI",
    noMorePosts: "แสดงบทความทั้งหมดแล้ว",
  },

  seo: {
    blogTitleFallback: "แปลเอกสารออนไลน์ | MikoTech",
    blogDescriptionFallback:
      "แปลเอกสารออนไลน์ได้รวดเร็ว แม่นยำ และปลอดภัย รองรับ PDF, Word, Excel, PPT และรูปภาพ",
    blogKeywordsFallback: "แปลเอกสาร, แปลไฟล์ pdf, แปลภาษาอังกฤษ",
  },

  payment: {
    complete: {
      title: "ข้อมูลไฟล์ที่ชำระเงินแล้ว",
    },

    fileName: "ชื่อไฟล์",
    fileSize: "ขนาดไฟล์",
    translateFrom: "แปลจาก",
    paymentStatus: "การชำระเงิน",

    paid: "ชำระเงินแล้ว",
    unpaid: "ยังไม่ได้ชำระเงิน",

    download: "ดาวน์โหลด",
    transactionNotFound: "ไม่พบรหัสธุรกรรม",
    expirationDate: "วันหมดอายุ",
    createFailed: "สร้างการชำระเงินไม่สำเร็จ",
    paypalSuccess: "ชำระเงินผ่าน PayPal สำเร็จ",
  },

  transaction: {
    title: "ประวัติการทำรายการ",
    note: "รายการไฟล์ที่อัปโหลดเพื่อแปล คุณสามารถชำระเงินหรือดาวน์โหลดไฟล์ที่แปลแล้วได้หลังจากชำระเงินสำเร็จ",
    fileDeleted: "ไฟล์นี้ถูกลบแล้ว",
    notiteDeleteFile: "คุณแน่ใจหรือไม่ว่าต้องการลบไฟล์นี้?",
    searchPlaceholder: "ค้นหาตามชื่อไฟล์...",

    table: {
      fileName: "ชื่อไฟล์",
      fileSize: "ขนาดไฟล์",
      language: "ภาษา",
      status: "สถานะ",
      price: "ราคา",
      action: "การดำเนินการ",
      expirationDate: "วันหมดอายุ",
    },

    status: {
      all: "สถานะทั้งหมด",
      paid: "ชำระเงินแล้ว",
      unpaid: "ยังไม่ได้ชำระเงิน",
    },
    delete: "ลบ",
    download: "ดาวน์โหลด",
    pay: "ชำระเงิน",
    mustPayFirst: "กรุณาชำระเงินก่อนดาวน์โหลด",
    getQrFail: "ไม่สามารถดึงรหัสชำระเงินได้",
  },

  pagination: {
    prev: "ก่อนหน้า",
    next: "ถัดไป",
  },

  faq: {
    title: "คำถามที่พบบ่อย",
    description:
      "ต้องการทำความเข้าใจเพิ่มเติมเกี่ยวกับบริการแปลเอกสารใช่ไหม? ดูคำตอบด้านล่างได้เลย",
  },

  translate: {
    terms:
      "เมื่อดำเนินการต่อ ฉันยืนยันว่าฉันยอมรับ<termsLink>ข้อกำหนดและนโยบาย</termsLink>ของแพลตฟอร์ม และรับผิดชอบทั้งหมดต่อการแปลที่ฉันดำเนินการเอง",
    selectTone: "เลือกโทนภาษา",
    analyzing_document: "กำลังวิเคราะห์เอกสาร...",
    extracting_content: "กำลังดึงเนื้อหา...",
    ai_translating: "กำลังแปลด้วย AI...",
    rebuilding_layout: "กำลังสร้างเค้าโครงใหม่...",
    finalizing_document: "กำลังจัดทำเอกสารให้เสร็จสมบูรณ์...",
    ai_processing:
      "กำลังประมวลผลเอกสาร ระบบจะทำงานต่อเนื่องโดยอัตโนมัติจนกว่าจะเสร็จสมบูรณ์",
    NotitePdf:
      " ขณะนี้ไฟล์ .PDF รองรับเฉพาะการแปลเนื้อหาข้อความภายในไฟล์ และยังไม่สามารถคงรูปแบบต้นฉบับได้ ผลลัพธ์ที่ส่งออกจะเป็นไฟล์ที่มีเนื้อหาที่แปลแล้วในรูปแบบข้อความล้วน",
  },

  translation: {
    fileRetentionNotice: "หมายเหตุ: ไฟล์จะถูกลบหลังจาก 30 วัน",
    keepThisPageOpen:
      "กรุณาเปิดหน้านี้ค้างไว้ เมื่อแปลเสร็จ ระบบจะปิดหน้าจอประมวลผลโดยอัตโนมัติและเปิดหน้าดูตัวอย่าง",
    emailNotice: "เมื่อเอกสารแปลเสร็จสมบูรณ์ ระบบจะส่งอีเมลแจ้งเตือนไปยังคุณ",
    processing: "กำลังประมวลผล",
    cancelTranslation: "ยกเลิกการแปล",
    cancelling: "กำลังยกเลิก...",
    cancelled: "ยกเลิกการแปลไฟล์แล้ว",
    cancelFailed: "ไม่สามารถยกเลิกการแปลได้ โปรดลองอีกครั้ง",
  },
  footer: {
    productOf: "© 2026. ผลิตภัณฑ์ของ Miko Tech",

    description:
      "แพลตฟอร์มแปลเอกสารออนไลน์ด้วย AI ที่ช่วยประมวลผลไฟล์ได้อย่างรวดเร็ว ใช้งานง่าย และปลอดภัย",
    badge: "แพลตฟอร์มแปลภาษาด้วย AI",
    contactTitle: "ข้อมูลติดต่อ",
    supportTitle: "นโยบายการสนับสนุน",

    copyright: "© 2026 Docme.vn. ผลิตภัณฑ์ของ Miko Tech.",
    terms: "ข้อกำหนด",
    privacy: "ความเป็นส่วนตัว",

    supportLinks: {
      termsAndPolicies: "นโยบายและข้อกำหนดการใช้งาน",
      paymentPolicy: "นโยบายการชำระเงิน",
      privacyPolicy: "นโยบายความเป็นส่วนตัว",
      userGuide: "คู่มือการใช้งาน",
      contactInfo: "ข้อมูลติดต่อ",
    },
  },
  fileSizeModal: {
    title: "ไฟล์มีขนาดเกินขีดจำกัดที่อนุญาต",
    heading: "ขนาดไฟล์ใหญ่เกินไป",
    descBefore: "ไฟล์ที่คุณเลือกมีขนาด",
    descAfter: "ระบบรองรับไฟล์ขนาดสูงสุด",
    confirm: "เข้าใจแล้ว",
  },
  address:
    "ชั้น 4B, 485B ถนนเหงียนดิ่งเจี๋ยว, แขวงบ่านเกอ, นครโฮจิมินห์, เวียดนาม",
  discount: {
    invalidCode: "รหัสส่วนลดไม่ถูกต้องหรือหมดอายุแล้ว",
    alreadyUsed: "รหัสส่วนลดนี้ถูกใช้งานไปแล้ว",
    applySuccess: "ใช้รหัสส่วนลดสำเร็จแล้ว",
    rollbackSuccess: "นำรหัสส่วนลดออกสำเร็จแล้ว",
    placeholder: "กรอกรหัสส่วนลด",
  },
  bottomMarquee: {
    text: "🎉 กรอกรหัส <strong>DOCME50</strong> เพื่อรับส่วนลด <strong>50%</strong> สำหรับค่าบริการแปลเอกสารครั้งแรก ใช้ได้ถึงวันที่ 30/08",
  },
  translationMode: {
    title: "เลือกรูปแบบการแปล",
    free: {
      title: "มาตรฐาน (ฟรี)",
      short: "มาตรฐาน (ฟรี)",
      desc: "เหมาะสำหรับเอกสารทั่วไปและประมวลผลได้รวดเร็ว",
    },
    paid: {
      title: "ขั้นสูง (มีค่าใช้จ่าย)",
      short: "ขั้นสูง (มีค่าใช้จ่าย)",
      desc: "แปลได้เป็นธรรมชาติ แม่นยำ และสอดคล้องกับบริบทมากยิ่งขึ้น",
    },
  },
  characterLimitModal: {
    title: "เกินขีดจำกัดการแปลฟรี",
    heading: "ไฟล์มีมากกว่า 30,000 ตัวอักษร",
    descBefore: "ไฟล์ของคุณมี",
    characters: "ตัวอักษร",
    descAfter:
      "ซึ่งเกินขีดจำกัด 30,000 ตัวอักษรสำหรับการแปลฟรี ระบบได้เปลี่ยนไฟล์นี้เป็นโหมดแปลแบบชำระเงินโดยอัตโนมัติ",
    confirm: "เข้าใจแล้ว",
  },
};

export default TH;
